/**
 * SLIDER
 * @author alexandre Flatrès
 * par artwaï pour artwaï
 *
 * JS sur le bloc slider
 */
var SliderMethods = (function () {

    const sliderVertical =  document.querySelectorAll('.swipe-container');

    sliderVertical.forEach(function(el) {
        NavBtn(el);
    }); 

    function NavBtn(el) {
        const gallery_scroller = el.querySelector('.swipe-container .swipe');
        const gallery_items = el.querySelectorAll('article[class*="card-"], li');
        const gallery_item_size = gallery_items[0].clientWidth;
        const gallery_prev = el.querySelector('.btn-carrousel.left');
        const gallery_next = el.querySelector('.btn-carrousel.right');
        const gallery_dots = el.querySelector('.slider-dots');
        var currentIndex = 0;
        
        if(gallery_prev && gallery_next) {
            gallery_prev.addEventListener('click', scrollToPrevPage, false);
            gallery_next.addEventListener('click', scrollToNextPage, false);
            
            var timer = null;
            gallery_scroller.addEventListener("scroll", function() {
                if(timer !== null) {
                    clearTimeout(timer);        
                }
                timer = setTimeout(function() {
                    // scrolled start
                    //console.log('next: ' + gallery_scroller.offsetWidth + " + " + gallery_scroller.scrollLeft + " >= " + gallery_scroller.scrollWidth);
                    if (gallery_scroller.offsetWidth + gallery_scroller.scrollLeft >= gallery_scroller.scrollWidth) {
                        gallery_next.setAttribute('disabled', 'disabled');
                        gallery_prev.removeAttribute('disabled');
                    } else {
                        gallery_next.removeAttribute('disabled');
                    }
                    // scrolled end
                    //console.log('prev: ' + gallery_scroller.scrollLeft + " <= " + gallery_item_size);
                    if (gallery_scroller.scrollLeft == 0 || gallery_scroller.scrollLeft < gallery_item_size - 10) { // gallery_scroller.scrollLeft <= gallery_item_size
                        gallery_prev.setAttribute('disabled', 'disabled');
                        gallery_next.removeAttribute('disabled');
                    } else {
                        gallery_prev.removeAttribute('disabled');
                    }
                }, 300);
            });
        }
        
        if(gallery_dots) {
            var observer = new IntersectionObserver(function(entries, observer) {
                // find the entry with the largest intersection ratio
                /*var activated = entries.reduce(function (max, entry) {
                    return (entry.intersectionRatio > max.intersectionRatio) ? entry : max;
                });*/

                /*if (activated.intersectionRatio > 0.5) {
                    currentIndex = elementIndices[activated.target.getAttribute("id")];
                    renderDots(gallery_dots);
                }*/

                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        currentIndex = elementIndices[entry.target.getAttribute("id")];
                        renderDots(gallery_dots);
                    }
                });
                
            }, {
                root:gallery_scroller, threshold:0.5
            });

            var elementIndices = {};
            for (var i = 0; i < gallery_items.length; i++) {
                gallery_dots.children[i].addEventListener("click", function(evt){
                    // A REVOIR, éviter le scrolltop au clique sur le dot (fonctionne pas avec preventDefault car on perd le système natif du scrollsnap et de l'ancre)
                    //evt.preventDefault(); 
                    //keepLocation(window.pageYOffset);
                });

                elementIndices[gallery_items[i].getAttribute("id")] = i;
                observer.observe(gallery_items[i]);
            }
        }

        el.classList.add('loaded');

        function renderDots(gallery_dots) {
            for (var i = 0; i < gallery_items.length; i++) {
                gallery_dots.children[i].classList.remove('active');
                if(i === currentIndex) {
                    gallery_dots.children[i].classList.add('active');
                }
            }
        }
        function scrollToPrevPage(evt) {
            evt.preventDefault();
            gallery_scroller.scrollBy(-gallery_item_size, 0);
            gallery_next.removeAttribute('disabled');
        }
        function scrollToNextPage(evt) {
            evt.preventDefault();
            gallery_scroller.scrollBy(gallery_item_size, 0);
            gallery_prev.removeAttribute('disabled');
        }
    }

    // [PATCH] No lose focus when input is focus
    function focusInput(intervalSlider = false) {
        if(intervalSlider != false) {
            var formInputs = document.querySelectorAll('form input:not([type=radio],[type=checkbox],[type=hidden]), form select, form textarea');
            if(sliderHero.length > 0 && formInputs.length > 0) {
                formInputs.forEach(input => {
                    // on focus input stop slider animation
                    input.addEventListener('focus', (e)=>{
                        clearInterval(intervalSlider);
                    });
    
                    // on blur refocus input
                    /*input.addEventListener('blur', (e)=>{
                        //console.log(document.activeElement.className);
                        setTimeout(function() { 
                            input.focus(); 
                        }, 1000);    
                    });*/
                });
            }
        }
    }

    // [PATCH] No jump to anchor (slider-dots click)
    function keepLocation(oldOffset) {
        //console.log(oldOffset);
        var st = 0;
        if (window.pageYOffset!= null){
            st = oldOffset;
        }
        if (document.body.scrollWidth!= null){
            st = oldOffset;
        }
        setTimeout('window.scrollTo(0,' + st + ')', 200);
    }

    // Throttle for scroll event listener
    function throttle(fn, wait) {
        var time = Date.now();
        return function() {
          if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
          }
        }
    }

    // Auto Slide
    function durationSlider(el, clear = false) {
        var listItems = el.querySelectorAll('.slider-dots a');
        var count = 1;
        var bottomHero = el.offsetHeight;
        
        if(listItems.length > 1) {
            // 6.5 sec d'intervalles entre chaque slide
            var intervalSlider = setInterval(function() {
                var newSlide = autoSlider(el, listItems, count);
                count = newSlide;
            }, 6500);

            focusInput(intervalSlider);

            // quand l'utilisateur clic sur un dot de navigation on stop l'animation
            listItems.forEach(node => {
                node.addEventListener("mousedown", function(){
                    clearInterval(intervalSlider);
                });
            });
            
        }

        // quand l'utilisateur scroll au moins 1/3 du slider on stop l'animation + check au onload
        ['scroll', 'onload'].forEach( evt => 
            window.addEventListener(evt, function() {
                var y = document['documentElement' || 'body'].scrollTop;
                if (y >= (bottomHero / 3)) {
                    clearInterval(intervalSlider);
                }
            })
        );
        

    }

    function autoSlider(el, listItems, count) {
        var nexLabel = el.querySelectorAll('.slider-dots a')[count];
        if(nexLabel !== undefined) {
            nexLabel.click();
        }      

        count += 1;
        if (count >= listItems.length) {
            count = 0;
        }
        return count;
    }

    let sliderMethods = {};      
    sliderMethods.InitNav = function(el) {
        return NavBtn(el);
    }
      
    return sliderMethods;

}());